// Service Form JavaScript
// Håndterer serviceaftale formular med dynamisk bil-detaljer visning

(function () {
// @ts-nocheck
"use strict";

  // Local state
  let carBrands = [];
  let isSubmitting = false;

  // Fetch last submission date for service form
  async function fetchLastSubmission() {
    const token = localStorage.getItem("carclub_token");
    if (!token) return null;

    try {
      const response = await fetch("/api/contact/last-service-submission", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        const data = await response.json();
        return data.lastSubmissionDate;
      }
    } catch (error) {
      console.error("Error fetching last service submission:", error);
    }
    return null;
  }

  // Display last submission indicator
  function displayLastSubmissionIndicator(lastDate) {
    if (!lastDate) return;

    const indicator = document.querySelector(
      '.last-submission-indicator[data-form-type="service"]'
    );
    if (!indicator) return;

    const dateSpan = indicator.querySelector(".submission-date");
    if (dateSpan) {
      const date = new Date(lastDate);
      const danishMonths = [
        "jan",
        "feb",
        "mar",
        "apr",
        "maj",
        "jun",
        "jul",
        "aug",
        "sep",
        "okt",
        "nov",
        "dec",
      ];
      const formatted = `${date.getDate()}. ${
        danishMonths[date.getMonth()]
      } ${date.getFullYear()}`;
      dateSpan.textContent = `Sidste indsendelse: ${formatted}`;
    }
    indicator.style.display = "flex";
  }

  // Load car brands from API
  async function loadCarBrands() {
    try {
      const response = await fetch(
        "https://bilhandel.dk/api/Search/SearchBrandAttributes"
      );
      carBrands = await response.json();

      // Populate dropdown
      const brandSelect = document.getElementById("serviceFormCarBrand");
      if (brandSelect && carBrands.length > 0) {
        carBrands.forEach((brand) => {
          const option = document.createElement("option");
          option.value = brand.value;
          option.textContent = brand.label;
          brandSelect.appendChild(option);
        });
      }
    } catch (error) {
      // Silent error - failed to load car brands
    }
  }

  // Toggle car details section based on checkbox
  function toggleCarDetails() {
    const checkbox = document.getElementById("serviceFormNoLicensePlate");
    const carDetailsSection = document.getElementById(
      "serviceFormCarDetailsSection"
    );
    const licensePlateInput = document.getElementById(
      "serviceFormLicensePlate"
    );
    const licensePlateError = document.getElementById(
      "error-serviceFormLicensePlate"
    );

    if (checkbox.checked) {
      // Vis bil detaljer
      carDetailsSection.style.display = "block";
      licensePlateInput.value = "";
      licensePlateInput.disabled = true;
      licensePlateInput.required = false;
      licensePlateError.textContent = "";

      // Gør bil detaljer required
      makeCarDetailsRequired(true);
    } else {
      // Skjul bil detaljer
      carDetailsSection.style.display = "none";
      licensePlateInput.disabled = false;
      licensePlateInput.required = false; // Enten nummerplade eller bil detaljer skal udfyldes

      // Fjern required fra bil detaljer
      makeCarDetailsRequired(false);
      clearCarDetailsErrors();
    }
  }

  // Make car detail fields required or not
  function makeCarDetailsRequired(required) {
    const fields = [
      "serviceFormCarBrand",
      "serviceFormCarModel",
      "serviceFormFirstRegistrationDate",
    ];

    fields.forEach((fieldId) => {
      const field = document.getElementById(fieldId);
      if (field) {
        field.required = required;
      }
    });

    // Radio buttons - check if at least one is selected
    const automaticRadios = document.getElementsByName(
      "serviceFormIsAutomaticTransmission"
    );
    const fourWheelRadios = document.getElementsByName(
      "serviceFormHasFourWheelDrive"
    );

    if (required) {
      // Add custom validation
      automaticRadios.forEach((radio) => {
        radio.setAttribute("data-required", "true");
      });
      fourWheelRadios.forEach((radio) => {
        radio.setAttribute("data-required", "true");
      });
    } else {
      automaticRadios.forEach((radio) => {
        radio.removeAttribute("data-required");
      });
      fourWheelRadios.forEach((radio) => {
        radio.removeAttribute("data-required");
      });
    }
  }

  // Clear car details errors
  function clearCarDetailsErrors() {
    const errorIds = [
      "error-serviceFormCarBrand",
      "error-serviceFormCarModel",
      "error-serviceFormFirstRegistrationDate",
      "error-serviceFormIsAutomaticTransmission",
      "error-serviceFormHasFourWheelDrive",
    ];

    errorIds.forEach((id) => {
      const errorElement = document.getElementById(id);
      if (errorElement) {
        errorElement.textContent = "";
      }
    });
  }

  // Validate single field
  function validateField(field) {
    const errorElement = document.getElementById(`error-${field.id}`);
    if (!errorElement) return true;

    errorElement.textContent = "";

    if (field.required && !field.value.trim()) {
      errorElement.textContent = "Dette felt er påkrævet";
      return false;
    }

    if (field.type === "email" && field.value) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(field.value)) {
        errorElement.textContent = "Indtast en gyldig email adresse";
        return false;
      }
    }

    if (field.type === "tel" && field.value) {
      const phoneRegex = /^\d{8}$/;
      if (!phoneRegex.test(field.value.replace(/\s/g, ""))) {
        errorElement.textContent = "Indtast et gyldigt 8-cifret telefonnummer";
        return false;
      }
    }

    if (field.type === "number" && field.value) {
      if (parseInt(field.value) < 0) {
        errorElement.textContent = "Værdien skal være positiv";
        return false;
      }
    }

    return true;
  }

  // Validate radio group
  function validateRadioGroup(name, errorId) {
    const radios = document.getElementsByName(name);
    const errorElement = document.getElementById(errorId);
    if (!errorElement) return true;

    errorElement.textContent = "";

    const isRequired = radios[0]?.getAttribute("data-required") === "true";
    if (!isRequired) return true;

    const isChecked = Array.from(radios).some((radio) => radio.checked);
    if (!isChecked) {
      errorElement.textContent = "Vælg venligst en mulighed";
      return false;
    }

    return true;
  }

  // Validate entire form
  function validateForm() {
    let isValid = true;

    // Validate basis felter
    const requiredFields = [
      "serviceFormName",
      "serviceFormPhone",
      "serviceFormEmail",
      "serviceFormMileage",
      "serviceFormKmPerYear",
    ];
    requiredFields.forEach((fieldId) => {
      const field = document.getElementById(fieldId);
      if (field && !validateField(field)) {
        isValid = false;
      }
    });

    const checkbox = document.getElementById("serviceFormNoLicensePlate");
    const licensePlate = document.getElementById("serviceFormLicensePlate");
    const licensePlateError = document.getElementById(
      "error-serviceFormLicensePlate"
    );

    if (!checkbox.checked) {
      // Hvis checkbox IKKE er markeret, skal NUMMERPLADE være påkrævet
      if (!licensePlate.value.trim()) {
        licensePlateError.textContent =
          "Indtast nummerplade eller marker 'Jeg har ikke nummerplade endnu'";
        isValid = false;
      }
    } else {
      // Hvis checkbox ER markeret, skal BILDETALJER være påkrævet
      const carDetailFields = [
        "serviceFormCarBrand",
        "serviceFormCarModel",
        "serviceFormFirstRegistrationDate",
      ];

      carDetailFields.forEach((fieldId) => {
        const field = document.getElementById(fieldId);
        if (field && !validateField(field)) {
          isValid = false;
        }
      });

      // Validate radio groups (kun når checkbox er markeret)
      if (
        !validateRadioGroup(
          "serviceFormIsAutomaticTransmission",
          "error-serviceFormIsAutomaticTransmission"
        )
      ) {
        isValid = false;
      }
      if (
        !validateRadioGroup(
          "serviceFormHasFourWheelDrive",
          "error-serviceFormHasFourWheelDrive"
        )
      ) {
        isValid = false;
      }
    }

    // Valider email permission (altid påkrævet)
    const emailPermissionCheckbox = document.getElementById(
      "serviceFormEmailPermission"
    );
    const emailPermissionError = document.getElementById(
      "error-serviceFormEmailPermission"
    );

    if (!emailPermissionCheckbox?.checked) {
      if (emailPermissionError) {
        emailPermissionError.textContent =
          "Du skal acceptere at modtage email kommunikation";
        emailPermissionError.style.display = "block";
      }
      isValid = false;
    }

    // Valider marketing consent hvis Car Club er valgt
    const isCarClubCheckbox = document.getElementById("serviceFormIsCarClub");
    const hasMarketingConsentCheckbox = document.getElementById(
      "serviceFormHasMarketingConsent"
    );
    const marketingConsentError = document.getElementById(
      "error-serviceFormHasMarketingConsent"
    );

    if (isCarClubCheckbox?.checked && !hasMarketingConsentCheckbox?.checked) {
      if (marketingConsentError) {
        marketingConsentError.textContent =
          "Du skal acceptere betingelserne for at blive medlem af Car Club";
        marketingConsentError.style.display = "block";
      }
      isValid = false;
    }

    return isValid;
  }

  // Get form data
  function getFormData() {
    const checkbox = document.getElementById("serviceFormNoLicensePlate");

    const formData = {
      name: document.getElementById("serviceFormName").value.trim(),
      phone: document.getElementById("serviceFormPhone").value.trim(),
      email: document.getElementById("serviceFormEmail").value.trim(),
      kmPerYear:
        parseInt(document.getElementById("serviceFormKmPerYear").value) || 0,
    };

    // Km stand er altid påkrævet
    const mileage = document.getElementById("serviceFormMileage").value;
    if (mileage) {
      formData.mileage = parseInt(mileage);
    }

    if (!checkbox.checked) {
      // Brug nummerplade
      const licensePlate = document
        .getElementById("serviceFormLicensePlate")
        .value.trim();
      if (licensePlate) {
        formData.licensePlate = licensePlate;
      }
    } else {
      // Brug bil detaljer
      formData.carBrand = document.getElementById("serviceFormCarBrand").value;
      formData.carModel = document
        .getElementById("serviceFormCarModel")
        .value.trim();

      const firstRegDate = document.getElementById(
        "serviceFormFirstRegistrationDate"
      ).value;
      if (firstRegDate) {
        formData.firstRegistrationDate = firstRegDate;
      }

      const automatic = document.querySelector(
        'input[name="serviceFormIsAutomaticTransmission"]:checked'
      );
      if (automatic) {
        formData.isAutomaticTransmission = automatic.value === "true";
      }

      const fourWheel = document.querySelector(
        'input[name="serviceFormHasFourWheelDrive"]:checked'
      );
      if (fourWheel) {
        formData.hasFourWheelDrive = fourWheel.value === "true";
      }
    }

    // Car Club medlemskab
    const isCarClubCheckbox = document.getElementById("serviceFormIsCarClub");
    const hasMarketingConsentCheckbox = document.getElementById(
      "serviceFormHasMarketingConsent"
    );

    formData.isCarClub = isCarClubCheckbox?.checked || false;
    formData.hasMarketingConsent =
      hasMarketingConsentCheckbox?.checked || false;

    return formData;
  }

  // Show loading state
  function showLoading(show) {
    const submitBtn = document.getElementById("serviceFormSubmitBtn");
    const submitText = document.getElementById("serviceFormSubmitText");
    const loadingText = document.getElementById("serviceFormLoadingText");

    if (show) {
      submitBtn.disabled = true;
      submitText.style.display = "none";
      loadingText.style.display = "inline";
    } else {
      submitBtn.disabled = false;
      submitText.style.display = "inline";
      loadingText.style.display = "none";
    }
  }

  // Show success message
  function showSuccessMessage() {
    const form = document.getElementById("serviceForm");
    const successMessage = document.getElementById("serviceFormSuccessMessage");

    form.style.display = "none";
    successMessage.style.display = "block";
  }

  // Show error message
  function showErrorMessage(message) {
    alert(message || "Der opstod en fejl. Prøv venligst igen.");
  }

  // Handle form submission
  async function handleSubmit(event) {
    event.preventDefault();

    if (isSubmitting) return;

    if (!validateForm()) {
      return;
    }

    isSubmitting = true;
    showLoading(true);

    try {
      const formData = getFormData();

      const headers = {
        "Content-Type": "application/json",
      };

      // Add Authorization header if user is logged in
      const token = localStorage.getItem("carclub_token");
      if (token) {
        headers.Authorization = `Bearer ${token}`;
      }

      const response = await fetch("/api/contact/service-agreement", {
        method: "POST",
        headers: headers,
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        showSuccessMessage();
      } else {
        const errorData = await response.json().catch(() => ({}));
        showErrorMessage(
          errorData.message || "Der opstod en fejl. Prøv venligst igen."
        );
      }
    } catch (error) {
      showErrorMessage("Der opstod en fejl. Prøv venligst igen.");
    } finally {
      isSubmitting = false;
      showLoading(false);
    }
  }

  // Initialize function
  // Helper function to check if user is logged in
  function isLoggedIn() {
    return !!localStorage.getItem("carclub_token");
  }

  // Setup modal triggers
  function setupModalTriggers() {
    const triggerBox = document.getElementById("serviceFormTrigger");
    const modalElement = document.getElementById("serviceFormModal");

    if (!triggerBox || !modalElement) {
      return;
    }

    const formModal = new bootstrap.Modal(modalElement);

    // Click event på trigger box - åbn modal direkte (ingen login check)
    triggerBox.addEventListener("click", function () {
      prefillFormDataIfLoggedIn();
      hideCarClubSectionIfLoggedIn();
      formModal.show();
    });
  }

  // Prefill form data hvis bruger er logget ind
  function prefillFormDataIfLoggedIn() {
    if (!isLoggedIn()) {
      return;
    }

    try {
      const userData = JSON.parse(localStorage.getItem("carclub_user") || "{}");

      const nameField = document.getElementById("serviceFormName");
      const emailField = document.getElementById("serviceFormEmail");
      const phoneField = document.getElementById("serviceFormPhone");

      if (nameField && userData.name) {
        nameField.value = userData.name;
      }
      if (emailField && userData.email) {
        emailField.value = userData.email;
      }
      if (phoneField && userData.phone) {
        phoneField.value = userData.phone;
      }
    } catch (error) {
      // Silent error - failed to prefill data
    }
  }

  // Skjul Car Club sektion hvis bruger er logget ind
  function hideCarClubSectionIfLoggedIn() {
    const isLoggedInUser = isLoggedIn();
    const carClubSection = document.getElementById("serviceFormCarClubSection");

    if (carClubSection) {
      carClubSection.style.display = isLoggedInUser ? "none" : "block";
    }
  }

  // Toggle marketing consent sektion
  window.toggleMarketingConsent = function (formPrefix) {
    const isCarClub = document.getElementById(
      `${formPrefix}IsCarClub`
    )?.checked;
    const consentSection = document.getElementById(
      `${formPrefix}MarketingConsentSection`
    );
    const consentCheckbox = document.getElementById(
      `${formPrefix}HasMarketingConsent`
    );

    if (!consentSection || !consentCheckbox) return;

    if (isCarClub) {
      consentSection.style.display = "block";
      consentCheckbox.required = true;
    } else {
      consentSection.style.display = "none";
      consentCheckbox.required = false;
      consentCheckbox.checked = false;

      // Clear error
      const errorElement = document.getElementById(
        `error-${formPrefix}HasMarketingConsent`
      );
      if (errorElement) {
        errorElement.textContent = "";
      }
    }
  };

  // Clear marketing consent error when checkbox is checked
  window.clearMarketingConsentError = function (formPrefix) {
    const errorElement = document.getElementById(
      `error-${formPrefix}HasMarketingConsent`
    );
    if (errorElement) {
      errorElement.textContent = "";
    }
  };

  async function initializeServiceForm() {
    // Setup modal triggers
    setupModalTriggers();

    // Load car brands
    loadCarBrands();

    // Fetch and display last submission
    const lastDate = await fetchLastSubmission();
    if (lastDate) {
      displayLastSubmissionIndicator(lastDate);
    }

    // Setup checkbox listener
    const checkbox = document.getElementById("serviceFormNoLicensePlate");
    if (checkbox) {
      checkbox.addEventListener("change", toggleCarDetails);
    }

    // Setup form submission
    const form = document.getElementById("serviceForm");
    if (form) {
      form.addEventListener("submit", handleSubmit);
    }

    // Setup field validation on blur
    const fields = document.querySelectorAll(".tjekleasing-form-input");
    fields.forEach((field) => {
      if (field.type !== "radio" && field.type !== "checkbox") {
        field.addEventListener("blur", function () {
          validateField(this);
        });
      }
    });

    // Setup radio button validation
    const radioGroups = [
      "serviceFormIsAutomaticTransmission",
      "serviceFormHasFourWheelDrive",
    ];

    radioGroups.forEach((groupName) => {
      const radios = document.getElementsByName(groupName);
      radios.forEach((radio) => {
        radio.addEventListener("change", function () {
          validateRadioGroup(groupName, `error-${groupName}`);
        });
      });
    });
  }

  // Initialize on page load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeServiceForm);
  } else {
    // DOM is already loaded
    initializeServiceForm();
  }
})();

// Global function to clear email permission error
window.clearEmailPermissionError = function (formPrefix) {
  const errorElement = document.getElementById(
    `error-${formPrefix}EmailPermission`
  );
  if (errorElement) {
    errorElement.textContent = "";
    errorElement.style.display = "none";
  }
};
